import { IMG } from "@/lib/brand";

const ITEMS = [
  { t: "Cremazione singola", d: "Cremazione individuale con restituzione delle ceneri in urna, per custodire per sempre il ricordo.", img: IMG.urne },
  { t: "Ritiro e custodia", d: "Ritiriamo la salma a domicilio o presso la clinica veterinaria, con mezzi autorizzati al trasporto SOA.", img: IMG.trasporto },
  { t: "Cremazione collettiva", d: "Cremazione collettiva nel pieno rispetto del Reg. CE 1069/2009.", img: IMG.sala },
];

export const Services = () => (
  <section id="servizi" className="py-20 lg:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.28em] text-[#997316] font-semibold">I nostri servizi</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0D3B52] mt-3">Accompagniamo ogni famiglia, passo dopo passo.</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {ITEMS.map((s, i) => (
          <article key={s.t} data-testid={`service-card-${i}`} className={`group rounded-3xl overflow-hidden border border-[#E2DDD5] bg-[#FAF8F5] ${i === 1 ? "md:translate-y-10" : ""}`}>
            <div className="h-60 overflow-hidden">
              <img src={s.img} alt={s.t} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-7">
              <h3 className="font-display text-2xl font-semibold text-[#0D3B52]">{s.t}</h3>
              <p className="text-sm text-[#5C6B73] mt-3 leading-relaxed">{s.d}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
